import { useEffect, useRef } from "react";
import styles from "./header.module.css";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export interface HeaderProps {
  containerAnimation?: gsap.core.Animation;
  worksLength:number
}
function Header(props: HeaderProps) {
  const backgroundRef = useRef<HTMLImageElement>(null);
  const timeline = useRef<GSAPTimeline>();
  const maskRef = useRef<HTMLDivElement>(null);
  const headerBoxRef = useRef<HTMLDivElement>(null);
  const loadingInfoComplateRef = useRef<HTMLDivElement>(null);
  const loadingState = useRef({
    loadingAnimation: false,
    headerBackgroundLoaded: false,
  });
  useEffect(() => {
    const ctx = gsap.context(() => {
      ScrollTrigger.matchMedia({
        "(min-width: 1024px)": function () {
          const workCtns = document.querySelectorAll(
            ".shadow-v60-work-ctn"
          ) as NodeListOf<HTMLElement>;
          const tl = gsap.timeline({
            paused: true,
            defaults: {
              ease: "power2.inOut",
            },
          });
          const workTitleSize = 100;
          tl.to(backgroundRef.current, {
            duration: 0.3,
            xPercent: "random(0,1)",
            yPercent: "random(-1,0)",
            filter: "blur(10px)",
          });

          tl.to(backgroundRef.current, {
            duration: 0.3,
            xPercent: "random(-1,0)",
            yPercent: "random(1,2)",
            filter: "blur(4px)",
          });

          tl.to(backgroundRef.current, {
            duration: 0.6,
            xPercent: "random(0,1)",
            yPercent: "random(-1,1)",
            filter: "blur(0px)",
          });

          tl.to(backgroundRef.current, {
            duration: 0.4,
            filter: "blur(10px)",
          });

          tl.to(backgroundRef.current, {
            duration: 0.8,
            filter: "blur(0px)",
          });

          tl.to(maskRef.current, {
            opacity: 1,
            duration: 0.2,
          });

          tl.to(maskRef.current, {
            opacity: 0,
            duration: 0.2,
          });

          tl.to(
            headerBoxRef.current,
            {
              opacity: 1,
              duration: 1,
              ease: "power4.out",
            },
            2.4
          );

          tl.to(
            `.${styles.frameTopRight}`,
            {
              duration: 0.4,
              x: -workTitleSize * props.worksLength,
            },
            2.8
          );

          tl.to(
            `.${styles.frameBottomRight}`,
            {
              duration: 0.4,
              x: -workTitleSize * props.worksLength,
            },
            2.8
          );

          tl.to(
            workCtns,
            {
              opacity: 1,
              duration: 1,
            },
            3
          );

          tl.to(
            `.${styles.frameBottomRight}`,
            {
              duration: 0.4,
              rotate: 45,
              opacity: 0,
            },
            3.4
          );

          tl.fromTo(
            `.${styles.arrow}`,
            {
              rotate: -45,
              opacity: 0,
              pointerEvents: "auto",
            },
            {
              duration: 0.8,
              rotate: 0,
              opacity: 1,
              onComplete: () => {
                document.body.classList.add("shadow-v60-loaded");
                gsap.to(".shadow-v60-nav", {
                  opacity: 1,
                  visibility: "visible",
                  pointerEvents: "auto",
                });
              },
            },
            3.4
          );

          timeline.current = tl;
        },
        "(max-width: 1023px)": function () {
          const workCtns = document.querySelectorAll(
            ".shadow-v60-work-ctn"
          ) as NodeListOf<HTMLElement>;
          const tl = gsap.timeline({
            paused: true,
            defaults: {
              ease: "power2.inOut",
            },
          });
          const workTitleSize = 100;
          tl.to(backgroundRef.current, {
            duration: 0.3,
            xPercent: "random(0,1)",
            yPercent: "random(-1,0)",
            filter: "blur(10px)",
          });

          tl.to(backgroundRef.current, {
            duration: 0.3,
            xPercent: "random(-1,0)",
            yPercent: "random(1,2)",
            filter: "blur(4px)",
          });

          tl.to(backgroundRef.current, {
            duration: 0.6,
            xPercent: "random(0,1)",
            yPercent: "random(-1,1)",
            filter: "blur(0px)",
          });

          tl.to(backgroundRef.current, {
            duration: 0.4,
            filter: "blur(10px)",
          });

          tl.to(backgroundRef.current, {
            duration: 0.8,
            filter: "blur(0px)",
          });

          tl.to(maskRef.current, {
            opacity: 1,
            duration: 0.2,
          });

          tl.to(maskRef.current, {
            opacity: 0,
            duration: 0.2,
          });

          tl.to(
            headerBoxRef.current,
            {
              opacity: 1,
              duration: 1,
              ease: "power4.out",
            },
            2.4
          );

          tl.to(
            `.${styles.frameBottomRight}`,
            {
              duration: 0.4,
              rotate: 45,
              opacity: 0,
            },
            2
          );

          tl.fromTo(
            `.${styles.arrow}`,
            {
              rotate: -45,
              opacity: 0,
              pointerEvents: "auto",
            },
            {
              duration: 0.8,
              rotate: 0,
              opacity: 1,
              onComplete: () => {
                document.body.classList.add("shadow-v60-loaded");
                gsap.to(".shadow-v60-nav", {
                  opacity: 1,
                  visibility: "visible",
                  pointerEvents: "auto",
                });
              },
            },
            2.4
          );

          timeline.current = tl;
        },
      });
    });

    return () => ctx.revert();
  }, []);
  useEffect(() => {
    const ctx = gsap.context(() => {
      // gsap.to(`.${styles.loadingInfo}`,{
      //   opacity:0.6,
      //   ease:"steps(1)",
      //   stagger:0.6,
      // })
      const loadingInfo = document.querySelectorAll(`.${styles.loadingInfo}`);
      const tl = gsap.timeline();
      loadingInfo.forEach((item) => {
        tl.to(item, {
          opacity: 0.6,
          duration: 0.6,
          ease: "steps(1)",
          onStart: () => {
            item.classList.add(styles.active);
          },
          onComplete: () => {
            item.classList.remove(styles.active);
          },
        });
      });

      tl.to(loadingInfoComplateRef.current, {
        opacity: 0.6,
        duration: 0.8,
        ease: "steps(1)",
        onStart: () => {
          loadingInfoComplateRef.current?.classList.add(styles.active);
        },
        onComplete: () => {
          loadingState.current.loadingAnimation = true;
          handleLoaded();
        },
      });
    });
    return () => ctx.revert();
  }, []);

  const handleLoaded = () => {
    if (
      loadingState.current.headerBackgroundLoaded === true &&
      loadingState.current.loadingAnimation === true
    ) {
      document
        .querySelector(`.${styles.loading}`)
        ?.classList.add(styles.disappear);
      timeline.current?.play();
    } else if (
      loadingState.current.loadingAnimation === true &&
      backgroundRef.current?.complete
    ) {
      document
        .querySelector(`.${styles.loading}`)
        ?.classList.add(styles.disappear);
      timeline.current?.play();
    }
  };

  // useEffect(() => {
  //   if(props.containerAnimation) {
  //     timeline.current?.play()
  //   }
  // },[props.containerAnimation])
  return (
    <div className={`${styles.ctn} shadow-v60-header`}>
      <img
        src="http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/v60photograph/v60photograph-home-banner.jpg
      "
        className={styles.backgroundImage}
        ref={backgroundRef}
        onLoad={() => {
          loadingState.current.headerBackgroundLoaded = true;
          handleLoaded();
        }}
      ></img>
      <div className={styles.mask} ref={maskRef}></div>

      <div className={styles.loading}>
        <div className={`${styles.loadingInfo} `}>
          正在准备相机<div>...</div>
        </div>
        <div className={`${styles.loadingInfo} `}>
          正在安装镜头<div>...</div>
        </div>
        <div className={`${styles.loadingInfo} `}>
          正在布光<div>...</div>
        </div>
        <div
          className={styles.loadingInfoComplate}
          ref={loadingInfoComplateRef}
        >
          准备拍摄<div>...</div>
        </div>
      </div>
      <svg
        width="6"
        height="6"
        viewBox="0 0 6 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${styles.frame} ${styles.frameTopLeft}`}
      >
        <path
          d="M0 0V-1H-1V0H0ZM0 1H6V-1H0V1ZM1 6V0H-1V6H1Z"
          fill="#CC7A29"
          mask="url(#path-1-inside-1_607_6562)"
        />
      </svg>

      <svg
        width="6"
        height="6"
        viewBox="0 0 6 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${styles.frame} ${styles.frameTopRight}`}
      >
        <path
          d="M6 0H7V-1H6V0ZM0 1H6V-1H0V1ZM5 0V6H7V0H5Z"
          fill="#CC7A29"
          mask="url(#path-1-inside-1_607_6562)"
        />
      </svg>

      <svg
        width="6"
        height="6"
        viewBox="0 0 6 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${styles.frame} ${styles.frameBottomRight}`}
      >
        <path
          d="M6 6V7H7V6H6ZM5 0V6H7V0H5ZM6 5H0V7H6V5Z"
          fill="#CC7A29"
          mask="url(#path-1-inside-1_607_6562)"
        />
      </svg>

      <svg
        width="6"
        height="6"
        viewBox="0 0 6 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${styles.frame} ${styles.frameBottomLeft}`}
      >
        <path
          d="M0 6H-1V7H0V6ZM6 5H0V7H6V5ZM1 6V0H-1V6H1Z"
          fill="#CC7A29"
          mask="url(#path-1-inside-1_607_6562)"
        />
      </svg>

      <div className={styles.headerBox} ref={headerBoxRef}>
        <svg
          width="509"
          height="80"
          viewBox="0 0 509 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.logo}
        >
          <g clip-path="url(#clip0_821_372)">
            <path
              d="M298.249 4.04445C302.689 1.19033 307.999 -0.0628735 313.244 0.00232217C369.739 0.038542 426.235 -0.0338977 482.724 0.0385419C496.284 -0.0990933 508.353 11.6579 508.831 25.1678V55.6142C507.991 64.0462 503.173 72.029 495.792 76.2885C491.242 79.0702 485.86 80.1133 480.579 79.9902C424.794 79.9612 369.008 79.9757 313.222 79.9829C309.817 79.9684 306.376 79.57 303.175 78.3603C293.315 74.8542 286.086 65.0748 285.832 54.5928C285.702 45.1395 285.775 35.6933 285.789 26.24C285.804 17.3516 290.671 8.69508 298.249 4.04445ZM310.621 12.1649C303.58 12.7734 297.734 19.264 297.828 26.3341C297.792 35.476 297.778 44.6251 297.836 53.7743C297.749 61.4673 304.754 68.197 312.418 67.9362C368.957 67.9507 425.496 67.9435 482.035 67.9362C489.475 68.2477 496.436 61.9817 496.726 54.5059C496.922 46.0739 496.719 37.6275 496.813 29.1882C496.885 25.8053 496.683 22.234 494.857 19.2785C492.206 14.5265 486.751 11.7448 481.369 12.0345C424.453 12.136 367.53 11.8752 310.621 12.1649Z"
              fill="white"
            />
            <path
              d="M0.0362165 17.3878C3.67269 13.86 5.73722 9.24562 7.41782 4.55878C10.3299 4.97168 13.1985 5.68159 16.0744 6.28284C15.7194 7.40565 15.3717 8.53571 15.0167 9.65853C20.0585 9.6875 25.0931 9.66577 30.1277 9.67301C30.1277 12.2156 30.1349 14.7655 30.1349 17.3082C27.5343 17.3226 24.9337 17.3226 22.3332 17.3299C22.3332 18.0108 22.3331 19.3872 22.3404 20.0681C25.4336 20.0753 28.534 20.0681 31.6272 20.0753C31.6272 22.647 31.6272 25.2113 31.6272 27.7829C29.1063 27.7829 26.5854 27.7829 24.0645 27.7829C26.9113 29.3186 29.7727 30.8399 32.5254 32.5422C30.1784 34.6285 27.7951 36.664 25.4191 38.7213C34.9159 38.7213 44.4128 38.7213 53.9168 38.7213C53.9024 48.1819 53.9458 57.6425 53.8879 67.0959C50.5122 67.1973 47.1292 67.1539 43.7536 67.1611C43.7391 66.6613 43.7246 65.6544 43.7101 65.1545C35.662 65.14 27.614 65.1545 19.5587 65.1473C19.3559 65.6036 18.9502 66.5309 18.7474 66.9945C15.6542 67.3784 12.5321 67.0959 9.4244 67.1539C9.4244 58.1424 9.4244 49.1309 9.43164 40.1194C8.403 40.6337 7.3816 41.1408 6.3602 41.6551C4.44779 39.2501 2.31083 37.0407 0 35.0124C3.99143 33.397 7.79451 31.1948 10.5762 27.8481C7.39609 27.7539 4.21599 27.7829 1.04313 27.7829C1.03588 25.2475 1.03589 22.7121 1.05037 20.1768C2.29634 20.1116 3.5423 20.0681 4.7955 20.0174C3.20907 19.1336 1.62265 18.2571 0.0362165 17.3878ZM9.32298 19.9667C10.243 20.0029 12.0902 20.0609 13.0174 20.0971C12.9739 18.9815 12.9088 17.8732 12.8363 16.7649C11.5324 17.6848 10.3444 18.7497 9.32298 19.9667ZM11.8077 38.7285C16.2772 38.7068 20.7467 38.7285 25.2162 38.7141C22.833 36.7727 20.4135 34.8748 17.9071 33.0927C16.0309 35.1355 14.0171 37.0552 11.8077 38.7285ZM19.1531 46.5086C19.1531 46.9504 19.1458 47.827 19.1458 48.2688C27.346 48.2761 35.5389 48.2761 43.7391 48.2688C43.7318 47.8342 43.7318 46.9504 43.7318 46.5086C35.5389 46.4941 27.346 46.5013 19.1531 46.5086ZM19.1458 55.4041C19.1458 55.8822 19.1458 56.8312 19.1458 57.3021C27.346 57.3093 35.5462 57.3093 43.7391 57.3021C43.7391 56.8312 43.7318 55.875 43.7246 55.4041C35.5317 55.3969 27.3387 55.3969 19.1458 55.4041Z"
              fill="white"
            />
            <path
              d="M228.982 5.79749C232.06 5.2397 235.146 4.68916 238.24 4.14587C239.102 6.76818 239.898 9.41223 240.579 12.0852C245.216 12.078 249.859 12.0852 254.495 12.078C254.495 14.9756 254.495 17.8732 254.495 20.7708C252.148 20.7708 249.801 20.749 247.461 20.7201C248.613 21.0388 249.772 21.3503 250.938 21.6618C249.837 24.3638 248.714 27.0585 247.577 29.7388C250.699 29.7605 253.821 29.7533 256.944 29.7605C256.972 32.7016 256.965 35.6354 256.965 38.5692C242.564 38.5692 228.17 38.5764 213.777 38.5692C213.769 35.6426 213.762 32.7088 213.813 29.7823C216.66 29.746 219.507 29.7605 222.361 29.7388C221.774 27.0803 220.898 24.5014 220.064 21.9081C221.397 21.5386 222.73 21.1692 224.063 20.7852C221.47 20.7563 218.884 20.7708 216.305 20.7635C216.174 17.8587 216.783 14.8017 215.704 12.0201C214.972 16.5765 210.923 20.0898 211.328 24.8708C211.357 38.9604 211.379 53.0426 211.314 67.1321C208.192 67.1756 205.069 67.1611 201.955 67.1611C201.94 56.8819 201.955 46.5955 201.94 36.3163C201.056 37.3232 200.173 38.3229 199.296 39.3298C197.681 35.8672 196.014 32.4191 194.124 29.0868C200.499 22.2413 205.106 13.9397 208.365 5.21073C211.466 6.18142 214.552 7.18833 217.645 8.18075C217.152 9.47742 216.5 10.7017 215.762 11.8752C220.658 12.2084 225.563 12.0852 230.46 12.0345C230.003 9.94828 229.503 7.86926 228.982 5.79749ZM229.069 20.7708C229.996 23.4076 231.14 26.0081 231.452 28.8116C230.93 29.0796 229.873 29.6229 229.344 29.8982C232.285 29.6736 235.233 29.7605 238.182 29.7533C239.283 26.8122 240.275 23.835 241.029 20.778C237.037 20.7563 233.053 20.7635 229.069 20.7708Z"
              fill="white"
            />
            <path
              d="M74.2285 8.83272C89.3974 8.84721 104.574 8.81099 119.742 8.84721C119.771 12.2374 119.757 15.6276 119.764 19.0177C104.602 18.9815 89.4336 19.0757 74.2792 18.967C74.1996 15.5913 74.2358 12.2084 74.2285 8.83272Z"
              fill="white"
            />
            <path
              d="M33.0759 9.54985C41.8846 9.54261 50.6932 9.54261 59.5091 9.54985C59.4946 18.3368 59.5309 27.1237 59.4874 35.9106C50.686 36.0483 41.8773 35.9396 33.0759 35.9686C33.0759 27.1599 33.0759 18.3513 33.0759 9.54985ZM42.283 18.2354C42.283 21.2271 42.283 24.2261 42.283 27.2179C44.7604 27.2179 47.2378 27.2179 49.708 27.2179C49.708 24.2261 49.708 21.2271 49.708 18.2354C47.2306 18.2354 44.7604 18.2354 42.283 18.2354Z"
              fill="white"
            />
            <path
              d="M135.259 20.5679C135.259 17.3009 135.252 14.0411 135.266 10.7741C152.384 10.8103 169.501 10.7306 186.612 10.8176C186.648 14.0701 186.633 17.3154 186.633 20.5679C178.795 20.5679 170.957 20.5679 163.112 20.5679C162.656 23.5669 162.2 26.5587 161.765 29.5577C168.009 29.746 174.261 28.9709 180.483 29.7533C180.143 38.0549 179.324 46.313 178.491 54.5711C182.541 54.5783 186.59 54.5566 190.639 54.6001C190.676 57.8526 190.661 61.1124 190.668 64.3722C171.008 64.3722 151.341 64.3722 131.681 64.3722C131.681 61.1052 131.688 57.8381 131.681 54.5783C136.599 54.5711 141.518 54.5783 146.437 54.5711C147.458 49.4931 148.407 44.4006 149.276 39.3008C145.814 39.2791 142.351 39.2936 138.896 39.2863C138.896 36.041 138.896 32.803 138.903 29.5577C142.88 29.5577 146.864 29.5577 150.848 29.5649C151.247 26.5659 151.638 23.5669 152.022 20.5679C146.437 20.5679 140.844 20.5679 135.259 20.5679ZM157.411 54.5711C160.925 54.5711 164.438 54.5783 167.951 54.5639C168.415 49.4786 168.849 44.3861 169.204 39.2936C166.198 39.2863 163.199 39.2863 160.193 39.2863C159.287 44.3861 158.375 49.4858 157.411 54.5711Z"
              fill="white"
            />
            <path
              d="M313.323 18.1702C318.14 18.1195 322.957 18.1485 327.782 18.1412C331.86 28.2321 336.395 38.1273 340.611 48.153C341.314 49.4858 341.799 51.5649 343.726 51.362C344.928 49.8698 345.588 48.0515 346.348 46.3202C350.282 36.9031 354.454 27.5873 358.315 18.1412C363.06 18.1629 367.805 18.0833 372.55 18.2064C367.689 29.8547 362.198 41.235 357.12 52.7891C355.418 56.7588 353.034 61.0182 348.666 62.4743C342.98 64.3215 335.613 63.4884 331.933 58.28C329.166 54.2379 327.608 49.5293 325.464 45.1539C321.443 36.1497 317.141 27.2614 313.323 18.1702Z"
              fill="white"
            />
            <path
              d="M390.225 18.1412C395.158 18.1557 400.084 18.0905 405.017 18.1919C402.46 23.212 398.78 27.5366 395.665 32.209C400.504 31.6874 405.394 31.6222 410.255 31.9482C414.876 32.209 419.324 34.6937 421.831 38.6126C425.648 44.3933 425.083 52.8543 420.128 57.8019C417.26 60.8878 413.036 62.3728 408.893 62.4308C402.837 62.5829 396.766 62.5032 390.71 62.4815C386.183 62.5177 381.54 60.8516 378.577 57.3238C374.064 52.3255 373.622 44.4223 377.099 38.7358C381.279 31.7526 386.06 25.1389 390.225 18.1412ZM391.681 41.8217C389.501 42.2201 387.523 44.2919 387.849 46.6027C388.023 49.1019 390.486 50.8984 392.898 50.7897C397.723 50.8549 402.554 50.9129 407.379 50.7535C409.921 50.7535 412.225 48.4427 411.993 45.8566C411.805 43.314 409.204 41.5609 406.778 41.6768C401.75 41.6768 396.694 41.445 391.681 41.8217Z"
              fill="white"
            />
            <path
              d="M446.025 18.5686C454.906 17.9529 465.048 16.888 472.611 22.618C481.007 28.7174 483.68 40.9669 479.138 50.1885C475.994 56.8674 469.126 61.4601 461.824 62.1917C456.971 62.6554 452.06 62.6554 447.206 62.199C440.078 61.5108 433.341 57.1572 430.081 50.7318C425.713 42.3795 427.235 31.26 434.029 24.639C437.217 21.3648 441.52 19.2785 446.025 18.5686ZM450.408 30.2604C445.996 30.34 441.534 33.1869 440.274 37.5333C438.905 41.6189 440.752 46.3637 444.359 48.6383C448.01 51.0216 452.581 50.442 456.725 50.5145C460.434 50.5869 464.498 49.6597 466.881 46.581C470.488 42.4737 469.547 35.4325 464.968 32.4408C460.796 29.2969 455.269 30.3328 450.408 30.2604Z"
              fill="white"
            />
            <path
              d="M66.6299 26.9643C86.5725 26.9643 106.515 26.9643 126.451 26.9643C126.451 30.3763 126.465 33.7882 126.429 37.2001C116.577 37.2146 106.725 37.1928 96.8734 37.2146C93.4325 42.4882 89.9265 47.74 85.8047 52.5138C92.7878 52.1733 99.7783 51.8184 106.769 51.4707C105.117 49.0005 103.444 46.5303 101.792 44.0601C104.864 42.4012 107.964 40.8076 111.079 39.2211C116.454 46.552 121.597 54.0785 126.03 62.0179C122.8 64.0534 119.533 66.031 116.251 67.9724C115.092 65.6544 113.904 63.3508 112.651 61.0834C102.459 61.8368 92.259 62.4598 82.0813 63.358C78.807 63.6188 75.5617 64.1476 72.3888 64.9662C71.2515 61.3514 70.0273 57.7657 68.5785 54.2668C75.2792 50.6231 78.8577 43.4806 82.668 37.2073C77.3365 37.2001 72.0121 37.2146 66.6806 37.1928C66.5937 33.7882 66.6299 30.3763 66.6299 26.9643Z"
              fill="white"
            />
            <path
              d="M218.717 41.4523C229.742 41.4668 240.768 41.4233 251.793 41.474C251.88 49.9495 251.808 58.4249 251.829 66.9003C248.772 66.8931 245.715 66.9365 242.658 66.8569C242.412 66.5019 241.912 65.8065 241.666 65.4588C237.269 65.0241 232.828 65.3863 228.41 65.2994C228.192 65.7268 227.743 66.5743 227.519 67.0017C224.599 67.3639 221.644 67.1032 218.717 67.1539C218.717 58.5843 218.71 50.0219 218.717 41.4523ZM227.982 50.1595C227.982 52.3037 227.982 54.448 227.982 56.5922C232.691 56.5922 237.399 56.5922 242.108 56.5922C242.108 54.448 242.108 52.3037 242.108 50.1595C237.399 50.1233 232.691 50.1306 227.982 50.1595Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_821_372">
              <rect width="509" height="80" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <div className={styles.header}>光影印象</div>
      </div>

      <svg
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.arrow}
        onClick={() => {
          gsap.to(window, {
            scrollTo: props.containerAnimation?.parent?.scrollTrigger?.labelToScroll(
              `ctn-scroll-0`
            ),
          });
        }}
      >
        <g clip-path="url(#clip0_768_11007)">
          <g>
            <path
              d="M6 114L116 4M116 4H6M116 4V114"
              stroke="#CC7A29"
              stroke-width="8"
              stroke-linecap="square"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_768_11007">
            <rect width="120" height="120" fill="#CC7A29" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default Header;
